import Component from '@glimmer/component'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { t } from 'ember-intl'

interface Args {
  fileUrl: string
  coverUrl: string
  title: string
}

interface Signature {
  Args: Args
  Element: HTMLAnchorElement
}

const COVER_IMAGE_HEIGHT = 250

export class CurriculumMapTile extends Component<Signature> {
  get adjustedCoverUrl() {
    const url = `${this.args.coverUrl}?h=${COVER_IMAGE_HEIGHT}`
    return url
  }

  <template>
    <a
      data-test-curriculum-map-tile
      href="{{@fileUrl}}"
      class="relative rounded-b-md border-2 shadow-xs hover:shadow-lg focus:shadow-lg"
      aria-label={{t "download"}}
      ...attributes
    >
      <div class="flex p-3">
        <img
          src="{{this.adjustedCoverUrl}}"
          class="border-dusty-black-100 mx-auto block h-36 rounded-md border border-solid p-1 shadow-xs"
          alt="{{@title}}"
          width="100"
        />
        <div class="w-1/2">
          <h4 class="mb-2 text-center">
            {{@title}}
          </h4>
          <PhosphorIcon @icon="phosphor-download-fill" class="absolute right-4 bottom-4 h-6 w-6" />
        </div>
      </div>
    </a>
  </template>
}

export default CurriculumMapTile
